import { useAuth } from "./AuthContext";
import { LoginScreen } from "./LoginScreen";
import { Shell } from "./Shell";
import { useAppRoute } from "./routes";
import { ChatScreen } from "../features/chat/ChatScreen";
import { KnowledgeScreen } from "../features/knowledge/KnowledgeScreen";
import { RetrievalScreen } from "../features/retrieval/RetrievalScreen";
import { UsersScreen } from "../features/users/UsersScreen";
import { KDNormativeWorkspace } from "../features/kd/KDNormativeWorkspace";
import { KDScreen } from "../features/kd/KDScreen";
import { KDMaterialsScreen } from "../features/kd/KDMaterialsScreen";
import { Spinner } from "../shared/ui/Primitives";

export function App() {
  const { user, loading } = useAuth();
  const route = useAppRoute();
  if (loading && !user) return <div className="app-loading"><Spinner label="Авторизация" /><span>Открываем помощника…</span></div>;
  if (!user) return <LoginScreen />;
  let page;
  switch (route.name) {
    case "kd-materials": page = <KDMaterialsScreen />; break;
    case "kd-sources": page = <KDNormativeWorkspace tab="instructions" />; break;
    case "kd-normative": page = <KDNormativeWorkspace tab={route.tab} />; break;
    case "kd": page = route.tab === "normative" ? <KDNormativeWorkspace /> : <KDScreen packageId={route.packageId} />; break;
    case "knowledge": page = <KnowledgeScreen route={route} />; break;
    case "retrieval": page = <RetrievalScreen />; break;
    case "users": page = <UsersScreen />; break;
    case "chat": default: page = <ChatScreen conversationId={route.conversationId} />;
  }
  return <Shell>{page}</Shell>;
}
